import React, { useEffect, useState } from "react";
import axios from "axios";
import AboutCard from "../../components/Common/AboutCard";
import NodataAvailable from "../../components/Common/NodataAvailable";
import ContentLoader from "../ContentLoader";
import i18n from "i18next";

const About = () => {
  const [details, setDetails] = useState("");
  const [loading, setLoading] = useState(true);
  const [title, setTitle] = useState("");

  const currentLang = i18n.language;
  
  useEffect(() => {
    axios.get(`/api/aboutus`).then((res) => {
      setLoading(false);
      if (res.status === 200) {
        setTitle(currentLang?.startsWith('en') ? res.data?.data.title : res.data?.data.title_bn);
        setDetails(currentLang?.startsWith('en') ? res.data?.data.details : res.data?.data.details_bn);
      }
    });
  }, [currentLang]);

  return (
    <>
      {loading ? (
        <ContentLoader />
      ) : (
        <>
          {details.length === 0 ? (
            <NodataAvailable />
          ) : (
            <AboutCard title={title} description={details} />
          )}
        </>
      )}
    </>
  );
};

export default About;
